export enum SupervisorTerritoryColumns {
  name,
  remove,
}
